import { createVNode as r, mergeProps as a } from "vue";
import d from "../node_modules/@pf-ui/pf-icon-svg/es/asn/Disconnected2TwotoneStandard.js";
import c from "../components/PfIcon.js";
const t = (o, e) => {
  const n = {
    ...o,
    ...e.attrs
  };
  return r(c, a(n, {
    icon: d
  }), null);
};
t.displayName = "Disconnected2TwotoneStandard";
t.inheritAttrs = !1;
export {
  t as default
};
